import type { AssetLite } from "@/entities/asset";

import { useAssetsBatchUpdate } from "@/entities/assets";
import { useBatchEditForm } from "@/modules/batch-edit-form";

import { getAssetsInitialReplacementCost } from "./assets-batch-edit-replacement-cost.helper";

const fieldName = "replacement_cost";

export const useAssetsBatchEditReplacementCost = (assets: AssetLite[]) => {
  const initialValue = getAssetsInitialReplacementCost(assets);

  const { mutate, isPending, status, error } = useAssetsBatchUpdate(assets);

  const onMutateReady = (value?: number | null) => {
    mutate({ [fieldName]: value ?? null });
  };

  const formProps = useBatchEditForm({
    fieldName,
    initialValue,
    onMutateReady,
    status,
    error,
  });

  return {
    ...formProps,
    fieldName,
    initialValue,
    isPending,
  };
};
